import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Image, Menu, Responsive, Dropdown } from "semantic-ui-react";
import * as auth from "../../shared/auth";
import ReactGA from "react-ga";
import { trackEvent } from "../../shared/tracking";
import * as utils from "../../shared/utils";
import { getPublicURL } from "../../shared/utils";
import { budgetURL, homeURL, loginURL, overviewURL } from "../../shared/urls/app";
import { callService, POST } from "../../shared/serviceInvoker";
import { logoutURL, statementURL } from "../../shared/urls/clientapi";
import ImpersonationBar from "../ImpersonationBar/index";

class Navbar extends Component {
  constructor(props) {
    super(props);

    let storedFirstName = "";
    if (sessionStorage.getItem("first_name")) {
      storedFirstName = sessionStorage.getItem("first_name");
    }

    this.state = {
      firstName: storedFirstName,
      downloading: false,
      showSubMenu: false,
    };

    this.handleLogout = this.handleLogout.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  /* =====================================================
     STATEMENT — FIXED
  ======================================================*/
  handleClick(event) {
    event.preventDefault();

    this.setState({ downloading: true });

    const url = statementURL.replace(
      "{contact_id}",
      sessionStorage.getItem("contact_id")
    );

    // =====================================================
    // FIRST CALL — GET RESPONSE TYPE
    // =====================================================
    callService(
      POST,
      url,
      {},
      (response) => {

        this.setState({ downloading: false });

        const data = response.data;

        // =========================================
        // RELIANT → OPEN NEW TAB
        // =========================================
        if (data && data.type === "external" && data.url) {
          window.open(data.url, "_blank");
          return;
        }

        // =========================================
        // EVERYTHING ELSE → DOWNLOAD PDF
        // =========================================
        callService(
          POST,
          url,
          {},
          (pdfResponse) => {

            const blob = new Blob([pdfResponse.data], {
              type: "application/pdf",
            });

            const fileURL = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = fileURL;
            a.download = "statement.pdf";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          },
          () => {
            console.log("PDF download failed");
          },
          "blob"
        );

      },
      () => {
        this.setState({ downloading: false });
      }
    );

    ReactGA.event({
      category: "Downloads",
      action: "User Downloaded Statement File",
    });

    trackEvent("Downloads", "User Downloaded Statement File");
  }

  handleLogout(event) {
    event.preventDefault();

    callService(
      POST,
      logoutURL,
      {},
      () => {
        auth.signOut();
        this.props.history.push(homeURL);
      },
      () => {
        auth.signOut();
        this.props.history.push(homeURL);
      }
    );
  }

  handleLogin(event) {
    event.preventDefault();
    this.props.history.push(loginURL);
  }

  handleToggle = () => {
    this.setState({ showSubMenu: !this.state.showSubMenu });
  };

  handleOnUpdate = (e, { width }) => {
    this.setState({
      showSubMenu: width >= Responsive.onlyTablet.minWidth,
    });
  };

  render() {
    const { downloading, showSubMenu } = this.state;

    return (
      <div>
        <Responsive fireOnMount onUpdate={this.handleOnUpdate}>
          <ImpersonationBar />

          <Menu color="blue" inverted secondary className="nopadding">

            <Menu.Item>
              <Image
                alt="Swift Logo"
                src={getPublicURL("images/swift_logo_square.png")}
                as={Link}
                to={overviewURL}
                avatar
              />
            </Menu.Item>

            {utils.isUserAuthenticated() && (
              <Menu.Menu position="right">

                <Menu.Item
                  name="statement"
                  disabled={downloading}
                  onClick={this.handleClick}
                >
                  STATEMENT
                </Menu.Item>

                <Menu.Item as={Link} to="/contactus">
                  SUPPORT
                </Menu.Item>

                <Dropdown item text="MY ACCOUNT">
                  <Dropdown.Menu>
                    <Menu.Item as={Link} to="/profile">
                      PROFILE
                    </Menu.Item>

                    <Menu.Item onClick={this.handleLogout}>
                      LOG OUT
                    </Menu.Item>
                  </Dropdown.Menu>
                </Dropdown>

              </Menu.Menu>
            )}

          </Menu>
        </Responsive>

        {showSubMenu && utils.isUserAuthenticated() && (
          <Menu
            stackable
            color="blue"
            secondary
            pointing
            className="nopadding ui menu secondary background"
          >
            <Menu.Item as={Link} to={overviewURL}>
              MY ACCOUNT
            </Menu.Item>

            <Menu.Item as={Link} to={budgetURL}>
              MY BUDGET
            </Menu.Item>
          </Menu>
        )}

      </div>
    );
  }
}

export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js